module.exports = __webpack_public_path__ + "img/budget-docking.7b991f66.svg";